var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalaysian(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18418_78182)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18418_78182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7619 -0.253906H-8V32.2544H40.7619V-0.253906Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7619 3.80859H-8V7.87174H40.7619V3.80859Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7619 11.936H-8V15.9992H40.7619V11.936Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7619 20.062H-8V24.1252H40.7619V20.062Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7619 28.1895H-8V32.2526H40.7619V28.1895Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.381 -0.253906H-8V17.2506H16.381V-0.253906Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1685 14.0625C9.05952 14.0625 7.34994 12.2436 7.34994 10C7.34994 7.7564 9.05961 5.93751 11.1685 5.93751C11.826 5.93751 12.4447 6.11444 12.985 6.42575C12.1376 5.54417 10.9787 5 9.69978 5C7.10418 5 5 7.2386 5 10C5 12.7614 7.10427 15 9.69978 15C10.9786 15 12.1376 14.4558 12.985 13.5742C12.4448 13.8856 11.826 14.0625 11.1685 14.0625Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.245 7.14258L12.923 8.65083L14.454 8.27444L13.7684 9.77865L14.9997 10.8175L13.4666 11.1851L13.4709 12.8569L12.245 11.811L11.019 12.8569L11.0233 11.1851L9.49023 10.8175L10.7215 9.77865L10.0358 8.27444L11.5669 8.65083L12.245 7.14258Z",
    fill: "#FFDA44"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18418_78182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18418_78182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7619,
    height: 32,
    fill: "white",
    transform: "translate(-8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysian);
export default __webpack_public_path__ + "static/media/malaysian.a0dcc5bba45c2ae87a3f374db32b120f.svg";
export { ForwardRef as ReactComponent };